export enum GtmEvent {
    SIGNUP = 'mb_portal_created_user',
    LOGIN = 'mb_portal_user_login',
    RETURN = 'mb_portal_return_user',
    LEFT = 'mb_portal_user_left',
    LOGOUT = 'mb_portal_user_logout',
    ABOUT_COMPLETED = 'mb_portal_about_completed',
    INSURANCE_LOOKUP_COMPLETED = 'mb_portal_insurances_found',
    INSURANCE_ADDED = 'mb_portal_insurance_completed',
    PRESCRIPTION_ADDED = 'mb_portal_prescriptions_added',
    LID_COLOR_SELECTED = 'mb_portal_your_medbox_selected',
    ONBOARDING_COMPLETED = 'mb_portal_onboarding_completed',
    VOICE_SEARCH_SUCCESS = 'mb_portal_voice_search_success',

    AUTO_COMPLETE_INPUT_INITIATED = 'mb_portal_auto_complete_input_initiated',
    AUTO_COMPLETE_INPUT_SUCCESS = 'mb_portal_auto_complete_success',
    AUTO_COMPLETE_USER_GAVE_UP = 'mb_portal_auto_complete_user_gave_up',
    LOGIN_DASHBOARD_ALREADY = 'mb_dashboard_login'
}

export enum DeliveryPackageStateEnum {
    OPEN = 'OPEN',
    LABEL_PRINTED = 'LABEL_PRINTED',
    IN_TRANSIT = 'IN_TRANSIT',
    DONE = 'DONE'
}

export enum DeliveryTicketStateEnum {
    OPEN = 'OPEN',
    IN_PRODUCTION = 'IN_PRODUCTION',
    PACKAGING = 'PACKAGING',
    PACKAGED = 'PACKAGED',
    LABEL_PRINTED = 'LABEL_PRINTED',
    READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
    OUT_THE_DOOR = 'OUT_THE_DOOR',
    DONE = 'DONE'
}

export enum InvoicesStateEnum {
    CLOSED = 'CLOSED',
    UNPAID = 'UNPAID',
    DONE = 'DONE',
    OPEN = 'OPEN',
    AUTHORIZED = 'AUTHORIZED',
    BAD_DEBT = 'BAD_DEBT',
    OVER_CHARGED = 'OVER_CHARGED'
}

export enum InvoiceCardTypesEnum {
    CHARGED = 'CHARGED',
    HOLD = 'HOLD'
}
